import { render, staticRenderFns } from "./businessUnitComponent.vue?vue&type=template&id=565dc212&scoped=true&"
import script from "./businessUnitComponent.vue?vue&type=script&lang=js&"
export * from "./businessUnitComponent.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitComponent.vue?vue&type=style&index=0&id=565dc212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565dc212",
  null
  
)

export default component.exports